module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pack-content",
    on: {
      "mouseup": _vm.mouseupHandler,
      "touchend": _vm.mousedownHandler,
      "mousemove": _vm.mouseupHandler,
      "touchmove": _vm.mouseupHandler
    }
  }, [_c('loading', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }]
  }), _vm._v(" "), (_vm.inited) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }],
    staticClass: "card-list-group"
  }, _vm._l((_vm.cards), function(card, index) {
    return _c('div', {
      key: index,
      staticClass: "card-item",
      class: card.classList,
      style: (_vm.cardStyle(card)),
      on: {
        "mousedown": function($event) {
          _vm.mousedownHandler(card)
        },
        "touchstart": function($event) {
          _vm.mousedownHandler(card)
        }
      }
    }, [_c('div', {
      staticClass: "bg-cover",
      class: _vm.isCardActive(card) ? 'active' : '',
      style: ('background-color: ' + card.bgColor)
    }), _vm._v(" "), _c(card.component, {
      tag: "component",
      staticClass: "card-inner",
      attrs: {
        "card-data": card
      }
    })], 1)
  })) : _vm._e()], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-4c7a8283", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-4c7a8283"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/views/pack/index.vue
// module id = 1068
// module chunks = 1